import { useQuery } from 'react-query';
import { api } from '../api';

const basePath = 'consults';

export interface IOrders {
  id?: number;
  consulta: string;
  correlation: string;
  subUsuario?: string;
  userPool?: string;
  dataConsulta?: any;
  placa?: string;
  renavam?: string;
  payloadConsulta?: any;
  payloadCaptura?: any;
  payloadComprovante?: any;
  status?: string;
  ip?: string;
  email?: string;
  origin?: string;
  subStatus?: string;
  subStatusLastUpdated?: Date;
  idApiKey?: number;
  created_at: string;
}

export interface IGetOrdersParams {
  text?: string;
  status?: string;
  dataInitialConsulta?: Date;
  dataEndConsulta?: Date;
  resultsPerPage?: number;
  page?: number;
  orderBy?: string;
  orderByDirection?: string;
}

export interface IGetOrders {
  results: IOrders[];
  nPages: number;
  total: number;
  resultsPerPage: string;
  currentPage: string;
}

export const getOrders = async (
  params: IGetOrdersParams,
): Promise<IGetOrders> => {
  const { data } = await api.get(basePath, { params });
  return data.data;
};

export function useOrdersInfo(params: IGetOrdersParams) {
  params.orderByDirection = params.orderByDirection?.toUpperCase();
  const queryKey = [
    basePath,
    params.orderByDirection,
    params.orderBy,
    params.text,
    params.status,
    params.dataInitialConsulta,
    params.dataEndConsulta,
    params.page,
    params.resultsPerPage,
  ];

  return useQuery(queryKey, () => getOrders(params), {
    staleTime: 60000,
  });
}
